document.querySelectorAll(".mainSlider").forEach((slider, index) => {
   new Swiper(slider, {
      effect: "slide",
      speed: 1e3,
      slidesPerView:1,
      pagination: {
        el: ".swiper-pagination",
      },
   });
});


document.querySelectorAll(".collectionSlider").forEach((slider, index) => {
   const prevArrow = slider.parentElement.querySelector(".prev"),
      nextArrow = slider.parentElement.querySelector(".next");
   new Swiper(slider, {
      effect: "slide",
      speed: 1e3,
      navigation: {
         nextEl: nextArrow,
         prevEl: prevArrow
      },
      breakpoints: {
         150: {
            slidesPerView: 2,
            spaceBetween: 10
         },
         576: {
            slidesPerView: 2.5,
            spaceBetween: 15
         },
         600: {
            slidesPerView: 3,
            spaceBetween: 25
         },
         900: {
            slidesPerView: 3,
            spaceBetween: 40
         },
      }
   })
});


document.querySelectorAll(".collectionListSlider").forEach((slider, index) => {
   const prevArrow = slider.parentElement.querySelector(".prev"),
      nextArrow = slider.parentElement.querySelector(".next");
   new Swiper(slider, {
      effect: "slide",
      speed: 1e3,
      navigation: {
         nextEl: nextArrow,
         prevEl: prevArrow
      },
      breakpoints: {
         150: {
            slidesPerView: 1.7,
            spaceBetween: 10
         },
         576: {
            slidesPerView:3,
            spaceBetween: 15
         },
         769: {
            slidesPerView: 3.5,
            spaceBetween: 20
         },
         1025: {
            slidesPerView: 4,
            spaceBetween: 20
         },
         1201: {
            slidesPerView: 4,
            spaceBetween: 30
         },
      }
   })
});